import {MultiSelect} from "primereact/multiselect";
import {Dropdown} from "primereact/dropdown";
import {Button} from "primereact/button";
import {Skeleton} from "primereact/skeleton";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import React, {useRef, useState} from "react";
import {InputSwitch} from "primereact/inputswitch";
import {addQueueSkillGroup, addQueueUser, addQueueUtilizationGroup, changeQueueSkillGroupLevel, changeQueueUserLevel, changeQueueUtilizationGroupIndex, deleteQueueSkillGroup, deleteQueueUser, deleteQueueUtilizationGroup, setQueueField} from "../../../redux/actions/actionsQueue";
import {InputNumber} from "primereact/inputnumber";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import {PROD} from "../../../redux/config";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import UserListDialog from "../../Settings/UsersList/UserDialod";
import {setEditType} from "../../../redux/actions/actions";
import {checkPermissions} from "../../../redux/permissions/permissionsUtils";
import {getUserDetails} from "../../../redux/api/apiUsersList";
import QualificationGroupDialog from "../../QualificationGroupList/QualificationGroupDialog";
import {getQualificationGroupDetails} from "../../../redux/api/apiQualificationGroup";

const QueueListDialogUsers = () => {
    const dispatch = useAppDispatch()
    // @ts-ignore
    const usersData = useAppSelector(state => state.CompaniesListReducer.usersData);
    // @ts-ignore
    const loadingStrategyDict = useAppSelector(state => state.CompaniesListReducer.loadingStrategyDict)
    // @ts-ignore
    const archiveTableToggle = useAppSelector(state => state.QueueListReducer.archiveQueueTableToggle)
    // @ts-ignore
    const errorFields = useAppSelector(state => state.QueueListReducer.errorFields);
    // @ts-ignore
    const queueData = useAppSelector(state => state.QueueListReducer.queueData);
    // @ts-ignore
    const queuesDirectoryQueueOperatorsType = useAppSelector(state => state.QueueListReducer.queuesDirectoryQueueOperatorsType);
    const editType = useAppSelector(state => state.UsersReducer.editType);
    const inputRef = useRef<any>(null);
    const skillGroupList = useAppSelector(state => state.QualificationGroupListReducer.skillGroupList);
    const rolesVision = useAppSelector(state => state.RolesReducer.rolesVision) as unknown as Record<string, string[]>;
    const usersManagerPermissions = checkPermissions(rolesVision, 'Users');
    const jwtToken = useAppSelector(state => state.UsersReducer.userData.jwtToken);
    const detailsLoading = useAppSelector(state => state.UsersListReducer.detailLoading);
    const queueDetailsLoading = useAppSelector(state => state.QueueListReducer.detailsLoading);
    const skillGroupDetailsLoading = useAppSelector(state => state.QualificationGroupListReducer.detailsLoading);
    const skillGroupPermissions = checkPermissions(rolesVision, 'SkillGroup');
    const [currentUserId, setCurrentUserId] = useState<any>(null);
    const {
        update: hasUsersManagerUpdatePermission,
        visible: hasUsersManagerVisiblePermission
    } = usersManagerPermissions;

    const {
        visible: hasRoleVisionPermission,
        update: hasRoleUpdatePermission,
    } = skillGroupPermissions;

    const usersIsBlock = queueData?.permission?.usersIsBlock;
    const skillGroupsIsBlock = queueData?.permission?.skillGroupsIsBlock;

    const sameSkillGroupId = (a: any, b: any) =>
        a != null && b != null && String(a) === String(b);

    const skillGroupRowId = (row: any) => row?.id ?? row?.skillGroupId;

    const isSkillGroupInCatalog = (skillGroupId: any) =>
        Boolean(
            skillGroupId != null &&
            skillGroupList?.some((sg: any) => sameSkillGroupId(skillGroupRowId(sg), skillGroupId))
        );

    const isUserInCatalog = (userId: any) =>
        Boolean(
            userId != null &&
            usersData?.some((user: any) => String(user.userId) === String(userId))
        );

    const mergePreservedSelectedItems = (
        selected: any[],
        existing: any[],
        getId: (item: any) => any,
        isInCatalog: (id: any) => boolean,
    ) => {
        const selectedIds = new Set(
            (selected || [])
                .map(getId)
                .filter((id: any) => id != null)
                .map((id: any) => String(id))
        );
        const result: any[] = [];
        const seen = new Set<string>();

        (existing || []).forEach((item: any) => {
            const id = getId(item);
            if (id == null) {
                return;
            }
            const key = String(id);
            const keep = !isInCatalog(id) || selectedIds.has(key);
            if (keep && !seen.has(key)) {
                seen.add(key);
                result.push(item);
            }
        });

        (selected || []).forEach((item: any) => {
            const id = getId(item);
            if (id == null) {
                return;
            }
            const key = String(id);
            if (!seen.has(key)) {
                seen.add(key);
                result.push(item);
            }
        });

        return result;
    };

    const canOpenSkillGroupDetails = (skillGroupId: any) => {
        if (queueDetailsLoading || skillGroupsIsBlock || !hasRoleVisionPermission) {
            return false;
        }
        return isSkillGroupInCatalog(skillGroupId);
    };

    const canEditSkillGroupDetails = (skillGroupId: any) =>
        Boolean(archiveTableToggle && hasRoleUpdatePermission && isSkillGroupInCatalog(skillGroupId));

    const skillGroupDetailsIcon = (skillGroupId: any) =>
        canEditSkillGroupDetails(skillGroupId) ? 'pi pi-pencil' : 'pi pi-eye';

    const buildSkillGroupOptions = (existingGroups: any[], withLevel = false) => {
        const queueId = queueData?.queue?.id;
        const fromDict: any[] = (skillGroupList || []).map(({isActive, ...data}: any) => {
            const gid = data.id ?? data.skillGroupId;
            return {
                ...data,
                id: gid,
                skillGroupId: gid,
                ...(withLevel ? {skillGroupLevel: 0} : {}),
                ...(queueId ? {queueId} : {}),
            };
        });
        const byId = new Map<string, any>(fromDict.map((sg: any) => [String(sg.skillGroupId ?? sg.id), sg]));

        (existingGroups || []).forEach((existing: any) => {
            const gid = existing.skillGroupId ?? existing.id;
            if (gid == null) {
                return;
            }
            const key = String(gid);
            const fromCatalog = byId.get(key);
            if (fromCatalog) {
                byId.set(key, {
                    ...fromCatalog,
                    ...existing,
                    skillGroupId: gid,
                    id: gid,
                    name: fromCatalog.name || existing.name || '',
                    ...(withLevel
                        ? {skillGroupLevel: existing.skillGroupLevel ?? fromCatalog.skillGroupLevel ?? 0}
                        : {}),
                    ...(queueId ? {queueId: existing.queueId ?? queueId} : {}),
                });
            } else {
                byId.set(key, {
                    ...existing,
                    skillGroupId: gid,
                    id: gid,
                    name: existing.name || '',
                    ...(withLevel ? {skillGroupLevel: existing.skillGroupLevel ?? 0} : {}),
                    ...(queueId ? {queueId: existing.queueId ?? queueId} : {}),
                });
            }
        });

        return Array.from(byId.values());
    };

    const skillGroupDataWithLevel = buildSkillGroupOptions(queueData?.skillGroups, true);
    const utilizationGroupDataWithLevel = buildSkillGroupOptions(queueData?.skillGroupsGarbage);

    const resolveGarbageSkillGroupName = (row: any) => {
        if (row?.name) {
            return row.name;
        }
        const sg = skillGroupList?.find((s: any) =>
            sameSkillGroupId(skillGroupRowId(s), row?.skillGroupId)
        );
        return sg?.name || '';
    };

    const utilizationGroupUsers = (() => {
        const mapped = skillGroupsIsBlock
            ? (queueData?.skillGroupsGarbage || []).map((row: any) => ({
                ...row,
                id: row.skillGroupId,
                skillGroupId: row.skillGroupId,
                name: row.name,
                displayOrder: row.displayOrder ?? row.skillGroupLevel ?? 1,
            }))
            : (queueData?.skillGroupsGarbage || []).map((companiesItem: any) => {
                const skillGroupId = companiesItem.skillGroupId ?? companiesItem.id;
                const user = skillGroupList.find((userItem: { id: any; }) =>
                    sameSkillGroupId(userItem.id, skillGroupId)
                );
                return {
                    ...companiesItem,
                    skillGroupId,
                    id: skillGroupId,
                    name: companiesItem.name || user?.name || '',
                    queueId: queueData?.queue?.id,
                    displayOrder: companiesItem.displayOrder ?? companiesItem.skillGroupLevel ?? 1,
                };
            });

        const byId = new Map<string, any>();
        mapped.forEach((item: any) => {
            if (item.skillGroupId == null) {
                return;
            }
            const key = String(item.skillGroupId);
            if (!byId.has(key)) {
                byId.set(key, item);
            }
        });
        return Array.from(byId.values());
    })();

    const filteredUtilizationSkillGroups = (queueData?.skillGroupsGarbage || [])
        .map((row: any) => {
            const name = resolveGarbageSkillGroupName(row);
            if (skillGroupsIsBlock || name) {
                return {
                    ...row,
                    skillGroupId: row.skillGroupId ?? row.id,
                    id: row.skillGroupId ?? row.id,
                    name,
                    displayOrder: row.displayOrder ?? row.skillGroupLevel ?? 1,
                };
            }
            return null;
        })
        .filter(Boolean);

    const usersDataWithUserLevel = (() => {
        if (usersIsBlock) {
            return (queueData?.queueUsers || []).map((user: any) => ({
                ...user,
                fullName: user.fullName || user.userName || '',
            }));
        }

        const fromDict = (usersData || []).map((userData: any) => ({
            ...userData,
            userLevel: 0,
            fullName: `${userData?.lastName} ${userData?.firstName} ${userData?.middleName ? ` ${userData.middleName}` : ''}`
        }));

        const byId = new Map(fromDict.map((user: any) => [String(user.userId), user]));

        (queueData?.queueUsers || []).forEach((queueUser: any) => {
            const key = String(queueUser.userId);
            const existing = byId.get(key);
            if (existing) {
                byId.set(key, {
                    ...existing,
                    userLevel: queueUser.userLevel ?? existing.userLevel ?? 0,
                    fullName: existing.fullName?.trim()
                        ? existing.fullName
                        : (queueUser.fullName || queueUser.userName || existing.fullName),
                    userName: existing.userName || queueUser.userName,
                });
            } else {
                byId.set(key, {
                    ...queueUser,
                    userLevel: queueUser.userLevel ?? 0,
                    fullName: queueUser.fullName || queueUser.userName || '',
                });
            }
        });

        return Array.from(byId.values());
    })();

    const userLevels: any = {};
    queueData?.queueUsers?.forEach((user: { userId: string | number; userLevel: any; }) => {
        userLevels[user.userId] = user.userLevel;
    });

    usersDataWithUserLevel?.forEach((user: { userId: string | number; userLevel: any; }) => {
        if (userLevels[user.userId] !== undefined) {
            user.userLevel = userLevels[user.userId];
        }
    });

    const filteredUsers = queueData?.queueUsers || [];

    const isUsersIdPresent = !!queueData?.queueUsers?.length;

    const userItems = queueData?.queueUsers?.map((queueItem: any, index: number) => {
        const userItem = usersDataWithUserLevel?.find(
            (user: any) => String(user.userId) === String(queueItem.userId)
        ) || queueItem;

        const userLevelError = errorFields?.queueUsers?.queueUsersWithoutLevel?.find((user: { userId: any; }) => user.userId === queueItem.userId);
        const displayName = (userItem.fullName || '').trim()
            || [userItem.lastName, userItem.firstName, userItem.middleName].filter(Boolean).join(' ')
            || userItem.userName
            || '';
        const canOpenUserDetails = !usersIsBlock && hasUsersManagerVisiblePermission &&
            usersData?.some((user: any) => String(user.userId) === String(userItem.userId));

        return (
            <div key={userItem.userId || index} className="flex align-items-center mb-2 p-0 w-full">
                {canOpenUserDetails && <Button
                    className="max-w-4rem p-button-secondary mr-3"
                    style={{minWidth: '40px'}}
                    loading={detailsLoading && currentUserId === userItem.userId}
                    disabled={!archiveTableToggle || detailsLoading}
                    icon={archiveTableToggle && hasUsersManagerUpdatePermission ? 'pi pi-pencil' : !archiveTableToggle || !hasUsersManagerUpdatePermission ? 'pi pi-eye' : ''}
                    onClick={() => {
                        setCurrentUserId(userItem.userId);
                        dispatch(getUserDetails(userItem.userId, jwtToken?.jwtToken, true));
                        if (hasUsersManagerUpdatePermission) {
                            dispatch(setEditType(true));
                        } else {
                            dispatch(setEditType(false));
                        }
                    }}/>}
                {usersIsBlock ? (
                    <InputText
                        className={classNames('w-full mr-2', {'opacity-100': archiveTableToggle && editType})}
                        disabled
                        value={displayName}
                    />
                ) : (
                    <div className="flex-grow-1 flex align-items-center m-0 p-0 min-w-0 overflow-hidden">
                        <span className="white-space-nowrap overflow-hidden text-overflow-ellipsis">{displayName}</span>
                    </div>
                )}
                <InputNumber
                    ref={inputRef}
                    value={userItem?.userLevel}
                    className={classNames('max-w-3rem w-3rem flex-shrink-0', {'p-invalid': errorFields?.queueUsers && userLevelError})}
                    disabled={!archiveTableToggle || !editType || usersIsBlock}
                    min={0} max={1000}
                    useGrouping={false}
                    onChange={(e) => dispatch(changeQueueUserLevel({queueId: queueData?.queue?.id, userId: userItem.userId, userLevel: e.value}))}
                />
                {!usersIsBlock && <Button name={userItem.userId}
                        onClick={() => {
                            dispatch(deleteQueueUser(userItem.userId));
                        }}
                        icon="pi pi-times"
                        className="delete-user p-button-secondary p-button-rounded p-button-text flex-shrink-0"
                        disabled={!archiveTableToggle || !editType}
                />}
            </div>
        )
    })

    function randomNumber(min: number, max: number) {
        return Math.floor(Math.random() * (max - min + 1) + min)
    }

    const campaignStrategyItemTemplate = (option: any) => {
        let typeName = queuesDirectoryQueueOperatorsType.map((item: { dictionaryId: number; name: any; }) => {
            if (item.dictionaryId === option) {
                return item.name
            }
        })
        return (
            <div className="p-multiselect-representative-option">
                {loadingStrategyDict && <Skeleton width={`${randomNumber(50, 85)}%`} height="1rem"/>}
                {!loadingStrategyDict && <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">
                    {typeName}
                </span>}
            </div>
        );
    }

    const selectedCampaignStrategyTemplate = (option: any) => {
        let typeName = queuesDirectoryQueueOperatorsType.map((item: { dictionaryId: number; name: any; }) => {
            if (item.dictionaryId === option) {
                return item.name
            }
        })
        if (option) {
            return (
                <span style={{marginLeft: '.5em', verticalAlign: 'middle'}} className="image-text">
                    {typeName}
                </span>
            );
        }

        return "Оберіть тип";
    }

    const usersDataItemTemplate = (option: any) => {
        if (usersIsBlock || option?.fullName) {
            return option.fullName || option.userName || '';
        }
        return usersData.map((item: any) => {
            if (item.userId === option.userId) {
                return `${item.lastName} ${item.firstName} ${item?.middleName ? ` ${item.middleName}` : ''}`
            }
        })
    }

    const campaignUsers = (() => {
        const mapped = (queueData?.queueUsers || []).map((companiesItem: any) => {
            const user = usersDataWithUserLevel?.find(
                (userItem: any) => String(userItem.userId) === String(companiesItem.userId)
            );
            return {
                ...companiesItem,
                ...user,
                userId: companiesItem.userId,
                userLevel: companiesItem.userLevel ?? user?.userLevel ?? 0,
                userName: user?.userName || companiesItem.userName,
                fullName: (user?.fullName || companiesItem.fullName || companiesItem.userName || '').trim(),
                isActive: user?.isActive,
            };
        });

        const byId = new Map<string, any>();
        mapped.forEach((item: any) => {
            if (item.userId == null) {
                return;
            }
            const key = String(item.userId);
            if (!byId.has(key)) {
                byId.set(key, item);
            }
        });
        return Array.from(byId.values());
    })();

    const skillGroupUsers = (() => {
        const byOptionId = new Map<string, any>(
            (skillGroupDataWithLevel || []).map((sg: any) => [String(sg.skillGroupId ?? sg.id), sg])
        );
        const seen = new Set<string>();
        const result: any[] = [];

        (queueData?.skillGroups || []).forEach((companiesItem: any) => {
            const skillGroupId = companiesItem.skillGroupId ?? companiesItem.id;
            if (skillGroupId == null) {
                return;
            }
            const key = String(skillGroupId);
            if (seen.has(key)) {
                return;
            }
            seen.add(key);
            const fromOption = byOptionId.get(key);
            if (fromOption) {
                result.push(fromOption);
                return;
            }
            const fromList = skillGroupList?.find((userItem: any) =>
                sameSkillGroupId(skillGroupRowId(userItem), skillGroupId)
            );
            result.push({
                ...companiesItem,
                skillGroupId,
                id: skillGroupId,
                name: companiesItem.name || fromList?.name || '',
                skillGroupLevel: companiesItem.skillGroupLevel ?? 0,
                isActive: companiesItem.isActive ?? fromList?.isActive,
                isArchive: companiesItem.isArchive ?? fromList?.isArchive,
                queueId: queueData?.queue?.id ?? companiesItem.queueId,
            });
        });
        return result;
    })();

    const filteredSkillGroups = skillGroupUsers;

    const isSkillGroupIdPresent = !!skillGroupUsers?.length;

    const skillGroupDataItemTemplate = (option: any) => {
        if (option?.name) {
            return option.name;
        }
        return skillGroupList?.map((item: any) => {
            if (item.id === option.skillGroupId) {
                return item.name
            }
        })
    }

    const skillGroupItems = filteredSkillGroups?.map((item: any, index: number) => {
        const fromList = skillGroupDataWithLevel?.find((sg: any) =>
            sameSkillGroupId(sg.skillGroupId ?? sg.id, item.skillGroupId)
        );
        const skillGroup = {
            ...item,
            name: item.name || fromList?.name || '',
            skillGroupLevel: item.skillGroupLevel ?? fromList?.skillGroupLevel ?? 0,
        };

        const userLevelError = errorFields?.campaignUsers?.campaignUsersWithoutLevel?.find((user: { userId: any; }) => user.userId === item.userId);

        return (
            <div key={skillGroup.skillGroupId || index} className="flex align-items-center mb-2 w-full">
                {canOpenSkillGroupDetails(skillGroup.skillGroupId) && <Button
                    className="max-w-4rem p-button-secondary mr-3"
                    style={{minWidth: '40px'}}
                    loading={skillGroupDetailsLoading && currentUserId === skillGroup.skillGroupId}
                    disabled={!archiveTableToggle || skillGroupDetailsLoading}
                    icon={skillGroupDetailsIcon(skillGroup.skillGroupId)}
                    onClick={() => {
                        if (!canOpenSkillGroupDetails(skillGroup.skillGroupId)) {
                            return;
                        }
                        setCurrentUserId(skillGroup.skillGroupId);
                        dispatch(getQualificationGroupDetails(skillGroup.skillGroupId, jwtToken?.jwtToken, true));
                        dispatch(setEditType(canEditSkillGroupDetails(skillGroup.skillGroupId)));
                    }}/>}
                {skillGroupsIsBlock ? (
                    <InputText
                        className={classNames('w-full mr-2', {'opacity-100': archiveTableToggle && editType})}
                        disabled
                        value={skillGroup.name || ''}
                    />
                ) : (
                    <div className="flex-grow-1 flex align-items-center m-0 p-0 min-w-0 overflow-hidden">
                        <span className="white-space-nowrap overflow-hidden text-overflow-ellipsis">{skillGroup.name}</span>
                    </div>
                )}
                <InputNumber
                    ref={inputRef}
                    value={skillGroup?.skillGroupLevel}
                    className={classNames('max-w-3rem w-3rem flex-shrink-0', {'p-invalid': errorFields?.campaignUsers && userLevelError})}
                    disabled={!archiveTableToggle || !editType || skillGroupsIsBlock}
                    min={0} max={1000}
                    useGrouping={false}
                    onChange={(e) => dispatch(changeQueueSkillGroupLevel({queueId: queueData?.queue?.id, skillGroupId: skillGroup.skillGroupId, skillGroupLevel: e.value}))}
                />
                {!skillGroupsIsBlock && <Button name={skillGroup.skillGroupId}
                        onClick={() => {
                            dispatch(deleteQueueSkillGroup(skillGroup.skillGroupId));
                        }}
                        icon="pi pi-times"
                        className="delete-user p-button-secondary p-button-rounded p-button-text flex-shrink-0"
                        disabled={!archiveTableToggle || !editType}
                />}
            </div>
        )
    });

    const utilizationGroupDataItemTemplate = (option: any) => {
        return resolveGarbageSkillGroupName(option);
    }

    const onUtilizationRowReorder = (e: { dragIndex: number; dropIndex: number; value: any[] }) => {
        const updatedRows = (e.value || []).map((row: any, index: number) => ({
            ...row,
            skillGroupId: row.skillGroupId ?? row.id,
            displayOrder: index + 1,
        }));
        dispatch(changeQueueUtilizationGroupIndex(updatedRows));
    };

    const utilizationGroupItems = () => {
        const filteredArray = [...(filteredUtilizationSkillGroups || [])]
            .sort((a: { displayOrder: number; }, b: { displayOrder: number; }) => a.displayOrder - b.displayOrder)
            .map((item: any, index: number) => ({
                ...item,
                skillGroupId: item.skillGroupId ?? item.id,
                name: resolveGarbageSkillGroupName(item),
                displayOrder: index + 1,
            }));

        const nameBodyTemplate = (rowData: any) => resolveGarbageSkillGroupName(rowData);

        if (skillGroupsIsBlock) {
            return filteredArray.map((row: any) => (
                <div key={row.skillGroupId} className="flex align-items-center mb-2 p-0">
                    <InputText
                        className={classNames('w-full', {'opacity-100': archiveTableToggle && editType})}
                        disabled
                        value={`${row.displayOrder} ${nameBodyTemplate(row)}`.trim()}
                    />
                </div>
            ));
        }

        const canReorder = Boolean(archiveTableToggle && editType);

        const buttonTemplate = (rowData: any) => (
            <Button
                name={rowData.skillGroupId}
                onClick={() => {
                    dispatch(deleteQueueUtilizationGroup(rowData.skillGroupId));
                }}
                icon="pi pi-times"
                className="delete-user p-button-secondary p-button-rounded p-button-text"
                disabled={!canReorder}
            />
        );

        const detailsBodyTemplate = (rowData: any) => {
            if (!canOpenSkillGroupDetails(rowData.skillGroupId)) {
                return null;
            }
            return (
                <Button
                    className="max-w-4rem p-button-secondary"
                    style={{minWidth: '40px'}}
                    loading={skillGroupDetailsLoading && currentUserId === rowData.skillGroupId}
                    disabled={!archiveTableToggle || skillGroupDetailsLoading}
                    icon={skillGroupDetailsIcon(rowData.skillGroupId)}
                    onClick={() => {
                        if (!canOpenSkillGroupDetails(rowData.skillGroupId)) {
                            return;
                        }
                        setCurrentUserId(rowData.skillGroupId);
                        dispatch(getQualificationGroupDetails(rowData.skillGroupId, jwtToken?.jwtToken, true));
                        dispatch(setEditType(canEditSkillGroupDetails(rowData.skillGroupId)));
                    }}
                />
            );
        };

        return (
            <DataTable
                className="w-full utilization-strategy-table"
                value={filteredArray}
                dataKey="skillGroupId"
                reorderableRows={canReorder}
                onRowReorder={onUtilizationRowReorder}
            >
                <Column rowReorder style={{width: '20px'}} />
                <Column field="displayOrder" className="text-center" style={{width: '40px', minWidth: '40px'}} />
                <Column field="id" body={detailsBodyTemplate} style={{width: '40px', minWidth: '40px'}} />
                <Column field="name" body={nameBodyTemplate} style={{minWidth: '8rem'}} />
                <Column body={buttonTemplate} style={{width: '20px'}} />
            </DataTable>
        );
    }

    const enrichSkillGroupWithName = (item: any) => {
        if (item?.name) {
            return {
                ...item,
                skillGroupId: item.skillGroupId ?? item.id,
            };
        }
        const sg = skillGroupList?.find(
            (s: any) =>
                s?.id != null &&
                (item?.skillGroupId ?? item?.id) != null &&
                String(s.id) === String(item.skillGroupId ?? item.id)
        );
        return {
            ...item,
            skillGroupId: item.skillGroupId ?? item.id ?? sg?.id,
            name: sg?.name || item?.name || '',
            isActive: item?.isActive ?? sg?.isActive,
            isArchive: item?.isArchive ?? sg?.isArchive,
        };
    };

    const addSkillGroup = (e: any) => {
        const selected = (e.value || []).map((item: any) => {
            const skillGroupId = item?.skillGroupId ?? item?.id;
            if (skillGroupId == null) {
                return null;
            }
            return enrichSkillGroupWithName({
                ...item,
                skillGroupId,
                id: skillGroupId,
                skillGroupLevel: item.skillGroupLevel ?? 0,
            });
        }).filter(Boolean);

        const updatedEValue = mergePreservedSelectedItems(
            selected,
            queueData?.skillGroups,
            (item: any) => item?.skillGroupId ?? item?.id,
            isSkillGroupInCatalog,
        ).map((item: any) => enrichSkillGroupWithName({
            ...item,
            skillGroupId: item.skillGroupId ?? item.id,
            skillGroupLevel: item.skillGroupLevel ?? 0,
        }));

        dispatch(addQueueSkillGroup({queueId: queueData?.id, skillGroupId: updatedEValue}));
    }

    const changeQueueUsers = (e: any) => {
        const updatedEValue = mergePreservedSelectedItems(
            e.value || [],
            queueData?.queueUsers,
            (item: any) => item?.userId,
            isUserInCatalog,
        );
        dispatch(addQueueUser({queueId: queueData?.id, userId: updatedEValue}))
    }

    const addUtilizationGroup = (e: any) => {
        const selected = (e.value || []).map((item: any) => {
            const skillGroupId = item?.skillGroupId ?? item?.id;
            if (skillGroupId == null) {
                return null;
            }
            return enrichSkillGroupWithName({
                ...item,
                skillGroupId,
                id: skillGroupId,
            });
        }).filter(Boolean);

        const updatedEValue = mergePreservedSelectedItems(
            selected,
            queueData?.skillGroupsGarbage,
            (item: any) => item?.skillGroupId ?? item?.id,
            isSkillGroupInCatalog,
        ).map((item: any) => enrichSkillGroupWithName({
            ...item,
            skillGroupId: item.skillGroupId ?? item.id,
        }));

        dispatch(addQueueUtilizationGroup({queueId: queueData?.id, skillGroupId: updatedEValue}))
    }

    return (
        <div className="users">
            <div className="grid p-fluid">
                <div className="field col-12 md:col-12 mb-0">
                    <h5 className="mr-2 mb-0">Опрацювання черги</h5>
                </div>
                <div className="field col-12 md:col-5">
                    <div className="field-radiobutton" style={{paddingBottom: '2px'}}>
                        <h6 className="mr-2 mb-0">Оператори</h6>
                        <InputSwitch disabled={!archiveTableToggle || !editType || usersIsBlock || skillGroupsIsBlock} checked={queueData?.queue?.isSkillGroup}  onChange={(e) => {
                            dispatch(setQueueField({section: 'queue', fieldName: 'isSkillGroup', value: e.value}));
                        }}/>
                        <h6 className="my-0 ml-2">Група кваліфікацій</h6>
                    </div>

                    {!queueData?.queue?.isSkillGroup && <div>
                        {!usersIsBlock && <MultiSelect
                        appendTo="self"
                        value={campaignUsers}
                        options={usersDataWithUserLevel}
                        onChange={(e) => {
                            changeQueueUsers(e)
                        }}
                        itemTemplate={usersDataItemTemplate}
                        placeholder="Оберіть користувачів"
                        filter
                        dataKey="userId"
                        optionLabel="fullName"
                        selectedItemsLabel={isUsersIdPresent ? `Користувачив обрано: ${filteredUsers?.length}` : ""}
                        maxSelectedLabels={0}
                        scrollHeight="250px"
                        className={classNames('field col-12 md:col-12 p-0', {'p-invalid': errorFields?.queueUsers && !queueData?.queueUsers?.length})}
                        disabled={!archiveTableToggle || !editType}
                    />}
                        {
                            queueData?.queueUsers?.length && isUsersIdPresent ?
                                <div className={usersIsBlock ? 'mt-3' : 'users-list'}>
                                    {userItems}
                                </div>
                                :
                                <span className="no-users-message">Користувачив не обрано</span>
                        }
                    </div>}
                    {queueData?.queue?.isSkillGroup && <div>
                        {!skillGroupsIsBlock && <MultiSelect
                            appendTo="self"
                            value={skillGroupUsers}
                            options={skillGroupDataWithLevel}
                            onChange={(e) => {
                                addSkillGroup(e);
                            }}
                            className={classNames('field col-12 md:col-12 p-0', {'p-invalid': errorFields?.queueUsers && !queueData?.queueUsers?.length})}
                            itemTemplate={skillGroupDataItemTemplate}
                            placeholder="Оберіть групу"
                            filter
                            dataKey="skillGroupId"
                            optionLabel="name"
                            selectedItemsLabel={isSkillGroupIdPresent ? `Груп обрано: ${filteredSkillGroups?.length}` : ""}
                            maxSelectedLabels={0}
                            scrollHeight="250px"
                            disabled={!archiveTableToggle || !editType}
                        />}
                        {
                            queueData?.skillGroups?.length && isSkillGroupIdPresent  ?
                                <div className={skillGroupsIsBlock ? 'mt-3' : 'users-list'}>
                                    {skillGroupItems}
                                    <div className="grid col-12 md:col-12">
                                        {errorFields?.campaignUsers && <div className="col-12 md:col-12 p-0 m-0 pl-2 mb-2 w-full"><span className="title p-error text-sm">{errorFields?.campaignUsers?.campaignUsers}</span></div>}
                                    </div>
                                </div>
                                :
                                <span className="no-users-message">Груп не обрано</span>
                        }
                    </div>}
                </div>
                <div className="field col-12 md:col-3">
                    <h6 className="pb-1">Стратегія оператор:</h6>
                    <Dropdown id="type"
                              appendTo="self"
                              filter
                              value={queueData.queue.strategyOperators}
                              options={queuesDirectoryQueueOperatorsType.map((item: { dictionaryId: number; }) => item.dictionaryId)}
                              onChange={e => {
                                  dispatch(setQueueField({section: 'queue', fieldName: 'strategyOperators', value: e.target.value}))
                              }}
                              itemTemplate={campaignStrategyItemTemplate}
                              valueTemplate={selectedCampaignStrategyTemplate}
                              disabled={!archiveTableToggle || !editType}
                              placeholder="Оберіть тип"
                    />
                </div>
                <div className="grid col-12 md:col-12">
                    {errorFields?.queueUsers && <div className="col-12 md:col-12 p-0 m-0 pl-2 mb-2 w-full"><span className="title p-error text-sm">{errorFields?.queueUsers?.queueUsers}</span></div>}
                </div>
            </div>
            {!PROD && <div className="p-divider p-component p-divider-horizontal p-divider-solid p-divider-left"></div>}
            <div className="grid p-fluid">
                <div className="field col-12 md:col-12 mb-0">
                    <h5 className="mr-2 mb-0">Стратегія утилізації</h5>
                </div>
                <div className="grid field col-12 md:col-12">
                    <div className="field col-12 md:col-4">
                        <h6>Група кваліфікацій</h6>
                        {!skillGroupsIsBlock && <MultiSelect
                            appendTo="self"
                            value={utilizationGroupUsers}
                            options={utilizationGroupDataWithLevel}
                            onChange={(e) => {
                                addUtilizationGroup(e);
                            }}
                            itemTemplate={utilizationGroupDataItemTemplate}
                            placeholder="Оберіть групу"
                            filter
                            dataKey="skillGroupId"
                            optionLabel="name"
                            selectedItemsLabel={filteredUtilizationSkillGroups?.length ? `Груп обрано: ${filteredUtilizationSkillGroups?.length}` : ""}
                            maxSelectedLabels={0}
                            scrollHeight="250px"
                            disabled={!archiveTableToggle || !editType}
                        />}
                        {
                            queueData?.skillGroupsGarbage?.length && filteredUtilizationSkillGroups?.length ?
                                <div className="users-list">
                                    {utilizationGroupItems()}
                                    <div className="grid col-12 md:col-12">
                                        {errorFields?.campaignUsers && <div className="col-12 md:col-12 p-0 m-0 pl-2 mb-2 w-full"><span className="title p-error text-sm">{errorFields?.campaignUsers?.campaignUsers}</span></div>}
                                    </div>
                                </div>
                                :
                                <span className="no-users-message">Груп не обрано</span>
                        }
                    </div>
                    <div className="field col-12 md:col-3">
                        <h6>Стратегія оператор:</h6>
                        <Dropdown id="type"
                                  appendTo="self"
                                  filter
                                  value={queueData.queue.strategyOperatorsForGarbage}
                                  options={queuesDirectoryQueueOperatorsType.map((item: { dictionaryId: number; }) => item.dictionaryId)}
                                  onChange={e => {
                                      dispatch(setQueueField({section: 'queue', fieldName: 'strategyOperatorsForGarbage', value: e.target.value}))
                                  }}
                                  itemTemplate={campaignStrategyItemTemplate}
                                  valueTemplate={selectedCampaignStrategyTemplate}
                                  disabled={!archiveTableToggle || !editType}
                                  placeholder="Оберіть тип"
                        />
                    </div>
                </div>
            </div>
            <UserListDialog skipBranchesFetch={queueData?.permission?.branchIsBlock}/>
            <QualificationGroupDialog skipBranchesFetch={queueData?.permission?.branchIsBlock}/>
        </div>
    )
}

export default QueueListDialogUsers
